module.exports = __webpack_public_path__ + "img/avatar-f3.c9bb9b27.png";